/**
 * textoTecnico — reconhece texto de PROGRAMA, pra ele nunca chegar ao cliente.
 *
 * [Bruno 2026-10-15] Espelho de backend/src/utils/erroCliente.js (mesmos
 * padrões): "Cannot read properties of undefined", "no such column", "SQLITE",
 * "TypeError", código cru em snake_case. Mensagem de negócio escrita pra gente
 * passa intacta. Lista de padrões de SISTEMA, não de assunto fiscal.
 */
const PADROES = [
  /cannot read propert/i,
  /cannot set propert/i,
  /is not a function/i,
  /is not defined/i,
  /\bundefined\b/i,
  /no such (column|table|function)/i,
  /\bsqlite/i,
  /constraint failed/i,
  /\b(Type|Reference|Syntax|Range)Error\b/,
  /\bE(CONNREFUSED|CONNRESET|TIMEDOUT|NOTFOUND|AI_AGAIN|PIPE)\b/,
  /socket hang up/i,
  /unexpected token/i,
  /\bJSON\b/,
  /\bat [\w.<>]+ \(/,
  /\/(app|src|node_modules)\//,
  /status code \d{3}/i,
  /^[a-z0-9]+(_[a-z0-9]+)+$/,
];

export const FRASE_ERRO_PADRAO = 'Não consegui concluir agora. Tente de novo em alguns minutos — se continuar, fale com a Marçal.';

export function pareceTecnico(texto) {
  const t = String(texto == null ? '' : texto).trim();
  if (!t) return true;
  return PADROES.some((re) => re.test(t));
}
